/** API Token endpoints — Faz 1.4 createApi factory ile yeniden yazıldı. */
import {createApi} from './_factory'
import type {ApiTokenNs} from '@shared/types'

const api = createApi('api-token')

export const ApiTokenApi = {
  getToken: (data: ApiTokenNs.ApiTokenRequest) =>
    api.post<ApiTokenNs.ApiTokenRequest, ApiTokenNs.ApiToken>('get', data),
  createToken: (data: ApiTokenNs.ApiTokenRequest) =>
    api.post<ApiTokenNs.ApiTokenRequest, ApiTokenNs.ApiToken>('create', data),
  removeToken: (data: ApiTokenNs.ApiTokenRequest) =>
    api.post<ApiTokenNs.ApiTokenRequest, ApiTokenNs.ApiToken>('remove', data),
}
